import { FilterGroup } from '../Tools/FilterGroup';
import { NameFilter } from '../Filters/NameFilter';
import { ObjectTypeFilter } from '../Filters/ObjectTypeFilter';
import { ColorFilter } from '../Filters/ColorFilter';
import { ShowPriorityFilter } from '../Filters/ShowPriorityFilter';
import { ShowUnavailableFilter } from '../Filters/ShowUnavailableFilter';
import { ShowRSEFilter } from '../Filters/ShowRSEFilter';
import { ShowContentFactoryFilter } from '../Filters/ShowContentFactoryFilter';
import { ShowNewObjectsFilter } from '../Filters/ShowNewObjectsFilter';
import { UniversesFilter } from '../Filters/UniversesFilter';
import { PriceRangeFilter } from '../Filters/PriceRangeFilter';
import { WidthRangeFilter } from '../Filters/WidthRangeFilter';
import { FiltersWidget } from '../FiltersWidget';
import { IFilter } from '../Tools/IFilter';
import { FiltersController } from '../Tools/FiltersController';
declare var AssetManagerServices: any;

export class AssetsFilterWidget extends FilterGroup {
    constructor(container: string) {
        super();
        this.id = 'assets';
        this.name = 'Objets';
        this.icon = 'fas fa-lg fa-cube';
        this.resource = 'assets';
        this.showPriority = (AssetManagerServices.ARRMGR_COUNTRY_ID === 175 || AssetManagerServices.ARRMGR_COUNTRY_ID === 176 || AssetManagerServices.ARRMGR_COUNTRY_ID === 177) || FilterGroup.mdmBusiness ? 'MDM' : 'REFERENCED';
        this.universes = {
            indoor: FiltersWidget.deliverable && FiltersWidget.deliverable.room_type !== 59 ? true : false,
            bathroom: false,
            outdoor: FiltersWidget.deliverable && FiltersWidget.deliverable.room_type === 59 ? true : false,
            junior: false,
            B2B: FilterGroup.mdmBusiness
        };
        this.minWidth = 0;
        this.maxWidth = 5000;

        this.minPrice = 0;
        this.maxPrice = 5000;
        this.filtersFunction = 'updateFilters';
        this.filters = [
            new NameFilter(this),
            new ObjectTypeFilter(this),
            new ColorFilter(this),
            new ShowPriorityFilter(this),
            new ShowUnavailableFilter(this),
            new ShowRSEFilter(this),
            new ShowContentFactoryFilter(this),
            new ShowNewObjectsFilter(this),
            new UniversesFilter(this),
            new PriceRangeFilter(this),
            new WidthRangeFilter(this),
        ];

        this.filtersHtml = () => {
            let AssetsFilterWidgetHtml = '';
            let showHtml = '<div class="noPadding" style="display: flex;flex-direction: row; justify-content: space-around;" id="showFilters">';
            let universesHtml = '';
            let rangeHtml = '';
            this.filters.forEach((filter: IFilter) => {
                if (filter.type.toLowerCase().search('show') !== -1
                    && filter.type.toLowerCase() !== 'showpriority') {
                    showHtml += `${filter.html()}`;
                } else if (filter.type.toLowerCase() === 'universes') {
                    universesHtml += `${filter.html()}`;
                } else if (filter.type.toLowerCase().search('range') !== -1) {
                    rangeHtml += `${filter.html()}`;
                } else {
                    AssetsFilterWidgetHtml += `${filter.html()}`;
                }
            });
            showHtml += '</div>';
            AssetsFilterWidgetHtml += showHtml + universesHtml + rangeHtml;
            return AssetsFilterWidgetHtml;
        }
        this.container = container;
        this.controller = new FiltersController();
    }

    generateStringFilter() {
        var i: number;
        let stringFilters = super.generateStringFilter();
        let filters = FilterGroup.filters;

        if (filters.style !== null && filters.style.length > 0) {
            stringFilters += '&q.styles._id.in=';
            for (i = 0; i < filters.style.length; i++) {
                if (i > 0) {
                    stringFilters += ',';
                }
                stringFilters += filters.style[i]._id;
            }
        }

        if (filters.roomType !== null && filters.roomType.length > 0) {
            stringFilters += '&q.environment.roomTypes.in=';
            for (i = 0; i < filters.roomType.length; i++) {
                if (i > 0) {
                    stringFilters += ',';
                }
                stringFilters += filters.roomType[i]._id;
            }
        }

        if (Array.isArray(filters.name)) {
            if (filters.name.length > 0) {
                if (FilterGroup.smartSearch()) {
                    stringFilters += '&q.kind.eq=Arrangement';
                    stringFilters += '&filter=' + filters.name.join(',');
                }
                else {
                    if (filters.sort && (filters.sort.price > 0 || filters.sort.width > 0)) {
                        stringFilters += '&q.labels.lk=' + filters.name.join(',');
                    }
                    else {
                        stringFilters += '&text=' + filters.name.join(',');
                    }
                }
            }
        }
        else if (filters.name) {
            if (FilterGroup.smartSearch()) {
                stringFilters += '&q.kind.eq=Arrangement';
                stringFilters += '&filter=' + filters.name;
            }
            else {
                if (filters.sort && (filters.sort.price > 0 || filters.sort.width > 0)) {
                    stringFilters += '&q.labels.lk=' + filters.name;
                }
                else {
                    stringFilters += '&text=' + filters.name;
                }
            }
        }

        let result = FilterGroup.initSortArray();
        stringFilters += result.stringFilter;
        let sort: any[] = result.sort;

        if (sort.length > 0) {
            stringFilters += '&sort=' + sort.join(',');
        }

        // We only want non kitchen fab objects
        if (!FiltersWidget.getDecorationService().displayGroups) {
            stringFilters += '&q.pipeline.modelState.eq=validated';
            stringFilters += '&q.pipeline.unrealState.eq=ready';
        }

        if (FilterGroup.filters.assets && FilterGroup.filters.assets.length > 0) {
            stringFilters += '&q._id.in=' + FilterGroup.filters.assets;
        }
        return stringFilters;
    };

    destroy(): void {
        super.destroy();
    }
}
